module.exports = __webpack_public_path__ + "static/media/drew.8d3a3cc7.jpg";